import { TId } from '@apia/util';
import { getTabContainer } from './util';
import { Tab, TTab } from '../../../tabs';

export class ApiaUtilTabsController {
  get currentTab(): Tab<TTab> {
    try {
      return getTabContainer().getHandler().getActiveTab();
    } catch (e) {
      e;
    }

    return {
      async close(_?: boolean) {
        try {
          window.close();
        } catch (_) {
          //
        }
        return true;
      },
      remove() {
        this.close();
      },
    } as any;
  }

  closeTab(tabId: string, force?: boolean) {
    const tabContainer = getTabContainer();
    if (tabContainer !== null) {
      tabContainer.getTab(tabId)?.close(force);
      return;
    } else {
      try {
        window.close();
      } catch (_ignore) {
        //
      }
    }
  }

  getHandler() {
    return getTabContainer()?.getHandler();
  }

  /**
   * openApiaTab y openTab son sinónimos.
   */
  openTab(title: string, url: string): Promise<TId> {
    const tabContainer = getTabContainer();
    if (tabContainer !== null) {
      return tabContainer.addNewTab(title, url);
    }

    return new Promise((resolve) => resolve(''));
  }
}
